<template>
  <div class="articleContent" @scroll="handleScroll">
    <div>
      <el-card class="office-card" shadow="never">
        <quick-entry :dataList="textContent"></quick-entry>
      </el-card>
    </div>
    <div class="title">
      <span class="title-sty">监管事项目录清单</span>
    </div>
    <div class="announcement">
      <div class="tips">
        <el-button style="font-size: 17px" @click="all()" :type="superviseAll"
          >全部监管事项</el-button
        >
        <el-button style="font-size: 17px" @click="same()" :type="superviseSame"
          >本级监管事项</el-button
        >
      </div>
      <p
        v-for="item in superviseList"
        :key="item.id"
        style="padding: 0 20px"
        class="clear-float::after"
      >
        <span class="spn">{{ item.kid }}</span>
        <!-- <router-link>{{item.title}}</router-link> -->
        <span class="spnT"
          ><span @click="jump(item)">{{ item.subitemItem }}</span></span
        >
      </p>
    </div>
  </div>
</template>
<script>
import { IndustryRegulation } from "../../utils/staticDict";
import { URL_FINDJGSXCATALOG, URL_PORTAL_GETLOCALLIST } from "../../utils/api";
import { frontHeater } from "../../utils/md5encryption";
import util from "../../utils/util";
import Vue from "vue";
export default {
  name: "industryManage",
  props: [],
  components: {
    "quick-entry": () => import("@/components/Home/QuickEntry.vue"),
  },
  data() {
    return {
      // 文字内容
      textContent: IndustryRegulation,
      // 全部监管
      superviseAll: "danger",
      supAll: true,
      // 本级监管
      superviseSame: "success",
      supSame: false,
      // 列表数据
      superviseList: [],
      kid: 1,
      judge: 1,
    };
  },
  computed: {},
  mounted() {
    if (this.judge == 1) {
      this.getList();
    }
  },
  methods: {
    handleScroll() {},
    // 请求全部监管事项列表数据
    getList() {
      let result = frontHeater([""], [""]);
      let Url = util.getAjaxUrl("axiosThree");
      let params = {
        currentPage: 1,
        pageSize: 999,
      };

      this.$http.defaults.headers.common["secretTime"] = result.timeStamp;
      this.$http.defaults.headers.common["secretSign"] =
        result.encryptionString;
      this.$http.defaults.headers.common["secretDefinite"] =
        result.parameterKey;
      this.$http.defaults.headers.common["appCode"] = result.secret;
      this.$http.post(Url + URL_FINDJGSXCATALOG, params).then((res) => {
        if (res.status == 200) {
          let id;
          this.kid = 1;
          let list = res.data.data.data;
          list.forEach((item) => {
            id = this.kid++;
            Vue.set(item, "kid", id);
          });
          this.superviseList = res.data.data.data;
        }
      });
    },
    // 请求本机监管事项列表数据
    getBenList() {
      let result = frontHeater([""], [""]);
      this.$http.defaults.headers.common["secretTime"] = result.timeStamp;
      this.$http.defaults.headers.common["secretSign"] =
        result.encryptionString;
      this.$http.defaults.headers.common["secretDefinite"] =
        result.parameterKey;
      this.$http.defaults.headers.common["appCode"] = result.secret;
      let Url = util.getAjaxUrl("axiosThree");
      this.$http.get(Url + URL_PORTAL_GETLOCALLIST).then((res) => {
        if (res.status == 200) {
          let id;
          this.kid = 1;
          let list = res.data;
          list.forEach((item) => {
            id = this.kid++;
            Vue.set(item, "kid", id);
          });
          this.superviseList = res.data;
        }
      });
    },
    async jump(e) {
      //  在新的页面打开
      let routerJump = await this.$router.resolve({
        path: "/home/supervision",
        query: {
          id: e.regulatoryLocalId,
          title: e.subitemItem,
          judge: this.judge,
        },
      });
      window.open(routerJump.href, "_blank");
    },
    all() {
      this.superviseAll = "danger";
      this.superviseSame = "success";
      this.judge = 1;
      this.getList();
    },
    same() {
      this.superviseAll = "success";
      this.superviseSame = "danger";
      this.judge = 0;
      this.getBenList();
    },
  },
};
</script>
<style scoped lang='less'>
@import "../../styles/base";
@import "../../styles/comSty";

p {
  line-height: 30px;
  // font-family: Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB,
  //   Microsoft YaHei, Arial, sans-serif;
  cursor: pointer;
  .spn {
    height: 30px;
    display: inline-block;
    width: 30px;
    color: #fff;
    background-color: #b71c1c;
    text-align: center;
    margin-right: 10px;
    border-radius: 3px;
    font-size: 14px;
    font-family: Helvetica Neue, "微软雅黑", Helvetica, Tahoma, Arial,
      "Microsoft Yahei", "Hiragino Sans GB", "WenQuanYi Micro Hei", sans-serif;
  }
  .spnT {
    display: inline-block;
    width: 95%;
    height: 30px;
    vertical-align: top;
    border-bottom: 1px dashed @border-color;
    color: #606266;
    > span {
      font-size: 16px;
      display: inline-block;
      width: 90%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      // white-space: pre-wrap;
      text-align: left;
      // text-indent: -2px;
      // font-family: Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB,
      //   Microsoft YaHei, Arial, sans-serif;
    }
  }
}
.spnT:hover {
  border-color: @black;
  color: @theme-color;
}
/deep/ .el-card__body {
  padding: 20px 0 !important;
}
</style>
